<mat-card-content class="p-0 m-b-10">
    <div class="row justify-content-between gap-16">
        <div class="col-lg-4">
            <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input matInput
                    placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.BILL_CHARGE' | translate }}"
                    [formControl]="searchBillCharge">
                <mat-icon matSuffix>
                    <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                </mat-icon>
            </mat-form-field>
        </div>
        <div class="col-lg-4 d-flex align-items-center justify-content-end">
            <button mat-flat-button color="primary" (click)="onAddBillCharge()">
                <mat-icon>add</mat-icon>
                {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.BILL_CHARGE' | translate }}
            </button>
        </div>
    </div>
</mat-card-content>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<mat-card class="p-0 m-0">
    <mat-card-content class="p-0">
        <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="dataSource" class="w-100">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ENTITY.BILL_CHARGE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.name}}
                    </td>
                </ng-container>

                 <ng-container matColumnDef="categorytype">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.INSURANCE_CHARGE_CATEGORY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.insuranceChargeCategoryId}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="charge">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.BILL_CHARGE_VALUE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">{{element.charge | currency:'INR'}}</td>
                </ng-container>

                <ng-container matColumnDef="Default">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DEFAULT_LABEL' | translate }}
                    </th>

                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        <mat-icon class="check-checkbox-icon text-primary">
                            {{ element.isDefault ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </td>

                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <a class="m-r-10 cursor-pointer" (click)="onUpdateBillCharge(element)"><i-tabler name="edit"
                                class="icon-18"></i-tabler></a>

                        <a class="m-r-10 cursor-pointer transition"
                            (click)="!isActionDisabled(element.name) && onDeleteBillCharge(element.id)">
                            <i-tabler name="trash" class="icon-18" [ngStyle]="{
                'opacity': isActionDisabled(element.name) ? '0.4' : '1',
                'cursor': isActionDisabled(element.name) ? 'default' : 'pointer',   
                        }">
                            </i-tabler>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">

            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>